

nn.component.FooterSection = function (element) {
  this.element = $(element);

  this.element.find('h5').on('click', function () {
    $(this).parent().toggleClass('active');
  });

};